import { HorizontalStack, Link, StatusColorBadge, TooltipPopOver, findStatus } from '@ztechapps/webui.util'
import React from 'react'
import type { Order, RouteDef } from '@ztechapps/common.contract'
import { InventoryBySerialNumberStatusEnum } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { InventoryBySerialNumberStatus as InventoryBySerialNumberStatusEntries } from '@ztechapps/inventorybyserialnumber.common'

type InventoryBySerialNumberStatusProps = {
  status?: InventoryBySerialNumberStatusEnum
  order?: Order
}

export const InventoryBySerialNumberStatusBadge = ({ status }: InventoryBySerialNumberStatusProps) => (
  <div className="text-uppercase">
    <StatusColorBadge status={status} color={findStatus(InventoryBySerialNumberStatusEntries, status)} />
  </div>
)

export const InventoryBySerialNumberStatus = ({ status, order }: InventoryBySerialNumberStatusProps) => {
  const orderItemRoute = useInject<RouteDef>(WebuiIocKey.routes.orderItem)
  const orderCode = order?.code

  //return as sold
  if (status === InventoryBySerialNumberStatusEnum.Sold && !isEmpty(orderCode)) {
    return (
      <HorizontalStack gap={2}>
        <InventoryBySerialNumberStatusBadge status={status} />
        <Link href={orderItemRoute.altPath({ _id: order?._id })}>
          <TooltipPopOver tooltipBody={`Sold to Sales Order #${orderCode}`}>
            <div>#{orderCode}</div>
          </TooltipPopOver>
        </Link>
      </HorizontalStack>
    )
  }

  //the fallback for all other status
  return <InventoryBySerialNumberStatusBadge status={status} />
}
